module.exports = __webpack_public_path__ + "img/food_normal.cc5ce2b6.png";